export default __webpack_public_path__ + "static/media/alert.b0a2b0d9.svg";